import temperature from './svg/Card_Temperature_en.svg';
import twelveweek from './svg/Card_TwelveWeek_en.svg';

export default [
  temperature,
  twelveweek,
];
